var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 108.65 109.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:url(#_2);}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#_2-2);}.cls-5{fill:url(#linear-gradient-2);}.cls-6{fill:url(#_2-3);}.cls-7{mix-blend-mode:hard-light;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_2",
    x1: 54.32,
    y1: 82.89,
    x2: 54.32,
    y2: 109.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c5f7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#b2eaf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#7fc9e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#2f94cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#2b92cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 54.32,
    y1: 57.52,
    x2: 54.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2b92cc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#81bee1",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c5e1f1",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#eff7fb",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_2-2",
    x1: 54.32,
    y1: 12.21,
    x2: 54.32,
    y2: 67.13,
    xlinkHref: "#_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 54.32,
    y1: 72.13,
    x2: 54.32,
    y2: 4.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2b92cc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#69bbe1",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#9bdbf1",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#b9effb",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#c5f7ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_2-3",
    x1: 54.32,
    y1: 34.32,
    x2: 54.32,
    y2: 92.89,
    xlinkHref: "#_2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "80.58 102.27 80.58 109.03 54.32 89.65 28.06 109.03 28.06 102.27 54.32 82.89 80.58 102.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.32,1.6l3.93,4.92L94.31,51.6h0l3.93,4.92H84.51L80.58,51.6,54.32,18.78,50.39,23.7,28.06,51.6l-3.93,4.92H10.39l3.93-4.92h0L50.39,6.52,54.32,1.6m0-1.6-.78,1L49.61,5.9,13.85,50.6h0l-.31.38L9.61,55.9l-1.3,1.62h16.3l.3-.37,3.93-4.92,22.33-27.9,3.15-3.95L79.8,52.23l3.93,4.92.3.37h16.3L99,55.9,95.1,51l-.3-.38h0L59,5.9,55.1,1l-.78-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "98.25 67.13 84.51 67.13 80.58 62.21 54.32 29.39 50.39 34.31 28.06 62.21 24.13 67.13 10.39 67.13 14.32 62.21 14.33 62.21 50.39 17.13 54.32 12.21 58.25 17.13 94.31 62.21 94.32 62.21 98.25 67.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M54.32,12.21l3.93,4.92L94.31,62.21h0l3.93,4.92H84.51l-3.93-4.92L54.32,29.39l-3.93,4.92L28.06,62.21l-3.93,4.92H10.39l3.93-4.92h0L50.39,17.13l3.93-4.92m0-8-3.9,4.89L46.49,14,11.93,57.21h0l-1.51,1.88L6.49,64,0,72.13H26.54L28,70.25,32,65.33,54.3,37.43l0,0L76.68,65.33l3.93,4.92,1.5,1.88h26.54L102.16,64l-3.93-4.92-1.5-1.88h0L62.16,14,58.23,9.09,54.32,4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "80.58 67.14 80.58 92.89 54.32 73.51 28.06 92.89 28.06 67.14 54.32 34.32 80.58 67.14"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "80.58 102.27 80.58 109.03 54.32 89.65 28.06 109.03 28.06 102.27 54.32 82.89 80.58 102.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.32,1.6l3.93,4.92L94.31,51.6h0l3.93,4.92H84.51L80.58,51.6,54.32,18.78,50.39,23.7,28.06,51.6l-3.93,4.92H10.39l3.93-4.92h0L50.39,6.52,54.32,1.6m0-1.6-.78,1L49.61,5.9,13.85,50.6h0l-.31.38L9.61,55.9l-1.3,1.62h16.3l.3-.37,3.93-4.92,22.33-27.9,3.15-3.95L79.8,52.23l3.93,4.92.3.37h16.3L99,55.9,95.1,51l-.3-.38h0L59,5.9,55.1,1l-.78-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "98.25 67.13 84.51 67.13 80.58 62.21 54.32 29.39 50.39 34.31 28.06 62.21 24.13 67.13 10.39 67.13 14.32 62.21 14.33 62.21 50.39 17.13 54.32 12.21 58.25 17.13 94.31 62.21 94.32 62.21 98.25 67.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M54.32,12.21l3.93,4.92L94.31,62.21h0l3.93,4.92H84.51l-3.93-4.92L54.32,29.39l-3.93,4.92L28.06,62.21l-3.93,4.92H10.39l3.93-4.92h0L50.39,17.13l3.93-4.92m0-8-3.9,4.89L46.49,14,11.93,57.21h0l-1.51,1.88L6.49,64,0,72.13H26.54L28,70.25,32,65.33,54.3,37.43l0,0L76.68,65.33l3.93,4.92,1.5,1.88h26.54L102.16,64l-3.93-4.92-1.5-1.88h0L62.16,14,58.23,9.09,54.32,4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "80.58 67.14 80.58 92.89 54.32 73.51 28.06 92.89 28.06 67.14 54.32 34.32 80.58 67.14"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlue);
export default __webpack_public_path__ + "static/media/Blue.58cc17c79bb9a47cc342583e2084feca.svg";
export { ForwardRef as ReactComponent };